<style lang="scss" scoped>


</style>

<template>
    <div>
        <div ref="modalComponent" class="modal modal-blur fade" tabindex="-1" style="display: none;"
        aria-hidden="true" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <slot name="title">
                            </slot>
                        </h5>
                        <button type="button" class="btn-close" aria-label="Close" @click="closeModal">
                        </button>
                    </div>
                    <div class="modal-body pb-0">
                        <slot>
                        </slot>
                    </div>
                    <div class="modal-footer mt-4 mb-1">
                        <slot name="footer">
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

export default {
    name: 'Modal',
    data: function () {
        return {
            modal: null
        }
    },
    mounted: function () {
        let self = this;
        
        let waitFor = setInterval(function() {
            if (window.bootstrap && self.$refs.modalComponent) {
                clearInterval(waitFor);
                let Modal = window.bootstrap.Modal;
                //self.modal = new Modal(self.$refs.modalComponent);
                self.modal = Modal.getOrCreateInstance(self.$refs.modalComponent); 
            }
        }, 100);
    },
    methods: {
        openModal: function () {
            let self = this;
        
            let waitFor = setInterval(function() {
                if (self.modal !== null) {
                    self.$nextTick( function () { 
                        clearInterval(waitFor);
                        self.modal.show();                   
                    });
                }
            }, 100);
        },
        closeModal: function () {
            let self = this;
        
            let waitFor = setInterval(function() {
                if (self.modal) {
                  clearInterval(waitFor);
                  self.modal.hide();
                }
            }, 100);
        }
    }
}

</script>